import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../lib/connect/clients';
export const projectActivityKeys = {
    all: [
        'projectActivity'
    ],
    list: (projectId, opts)=>[
            ...projectActivityKeys.all,
            'list',
            projectId,
            opts?.pageSize,
            opts?.entryTypes
        ]
};
export function useProjectActivity(projectId, options = {}) {
    const { pageSize = 50, entryTypes = [], refetchInterval = 30000 } = options;
    return useQuery({
        queryKey: projectActivityKeys.list(projectId ?? '', {
            pageSize,
            entryTypes
        }),
        queryFn: async ()=>{
            if (!projectId) return {
                entries: [],
                totalCount: 0
            };
            const response = await projectDataClient.listProjectActivity({
                projectId,
                entryTypes,
                pagination: {
                    pageSize,
                    pageToken: ''
                }
            });
            return {
                entries: response.entries ?? [],
                totalCount: response.pagination?.totalCount ?? 0
            };
        },
        enabled: !!projectId,
        staleTime: 15000,
        refetchInterval
    });
}
